import { parse, differenceInYears, isBefore } from 'date-fns';
import { dateFormats } from 'utils/date';

const validateDateOfBirth = (date: string | undefined) => {
    if (!date) {
        return false;
    }
    const now = new Date();
    const parsedDate = parse(date, dateFormats.monthDayYear, new Date());
    const diff = differenceInYears(now, parsedDate);
    return diff <= 125 && isBefore(parsedDate, now);
};

export { validateDateOfBirth };
